import { type Ref, ref, watch } from "vue";

/*
 * Composable to manage a loading state that is withheld if resolved
 * within a given threshold period. This can be used to avoid showing
 * loading indicators if the interaction is fast enough.
 */
export function useDeferredLoading({ threshold = 200, loadingState }: { threshold?: number; loadingState?: Ref<boolean> } = {}) {
    const loadingTimeout = ref<number | null>(null);
    const loading = ref(false);

    if (loadingState) {
        watch(
            loadingState,
            () => {
                if (loadingState.value) {
                    start();
                } else {
                    stop();
                }
            },
            { immediate: true },
        );
    }

    function start() {
        loadingTimeout.value = window.setTimeout(() => {
            loading.value = true;
        }, threshold);
    }

    function stop() {
        if (loadingTimeout.value) {
            clearTimeout(loadingTimeout.value);
            loadingTimeout.value = null;
        }

        if (loading.value) {
            loading.value = false;
        }
    }

    return {
        loading,
        start,
        stop,
    };
}
